import { useSeo } from "../lib/useSeo";
import { motion } from "framer-motion";
import { ASSETS, MEDIA } from "../lib/constants";
import { PageHero } from "../components/bits";

export default function Media() {
  useSeo("/media");
  return (
    <div data-testid="media-page">
      <PageHero
        label="Gallery"
        title="Media"
        subtitle="A look inside Higher Ground DC — our space, our products, our community. More imagery coming soon."
        image={ASSETS.groupPatio}
        testid="media-hero"
      />

      <section className="bg-ink py-16 md:py-24">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
            {MEDIA.map((m, i) => (
              <motion.figure
                key={m.src}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.08 }}
                className="group relative block break-inside-avoid overflow-hidden border border-white/10"
                data-testid={`media-item-${i}`}
              >
                <img src={m.src} alt={m.label} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end bg-gradient-to-t from-ink via-ink/40 to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="text-xs uppercase tracking-[0.2em] text-gold">{m.label}</span>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
